import type { GenericError, RequestStatus } from '@skynet/data-ws-core';

export enum LoanFundsCommands {
  LoanFunds = 'LoanFunds',
  AddCommittedFunds = 'AddCommittedFunds',
}
export interface JsonLoanFundsSuccess {
  command: 'LoanFunds';
  loanID: number;
  funds: LoanFundsItem[];
}
export interface LoanFundsItem {
  key: number;
  amount: number;
  token: string;
  author: string;
  date: string;
}
export interface LoanFundsState {
  committedFunds: LoanFundsItem[];
  initialCommittedFunds: number | null;
  status: RequestStatus;
  error: GenericError | null;
}
